import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { ViewEncapsulation } from '@angular/core';

import { Alert } from 'src/app/alert/alert';
import { AlertType } from 'src/app/alert/alert-type';
import { AlertService } from 'src/app/alert/alert.service';
import { AuthenticationService } from '@mango/authentication';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'mtp-alert-popup',
    templateUrl: './alert-popup.component.html',
    styleUrls: ['./alert-popup.component.css']
})
export class AlertsPopupComponent implements OnDestroy {

    protected onDestroy$ = new Subject<void>();

    alerts: Alert[];
    alertType = AlertType;
    loading: boolean;
    currentUserId: number;

    constructor(private service: AlertService, private authService: AuthenticationService) { }

    ngOnInit() {
        this.currentUserId = +this.authService.currentUser.id;

        this.loadAlerts();

        this.service.hubSubject.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            if (data == null || data == this.currentUserId) {
                this.loadAlerts();
            }
        });
    }

    loadAlerts() {
        this.loading = true;
        this.service.get({properties: ['title', 'date', 'message'], orderBy: [-2]}).toPromise().then(x => {
            if (x.totalCount != 0) {
                this.alerts = x.data;
            }

            this.loading = false;
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    getColor(alert: Alert): string {
        switch (alert.type) {
            case AlertType.Notification:
                return '#23a5df';
            default:
                return '#23a5df';
        }
    }

    getIcon(alert: Alert): string {
        switch (alert.type) {
            case AlertType.Notification:
                return 'info';
            default:
                return 'info_outline';
        }
    }
}
